(() => {
  const ROOT_SELECTOR = '[data-unbegun-preorder]';

  function formFor(root) {
    return root?.closest('form[data-product-form], form[action*="/cart/add"]');
  }

  function modalFor(root) {
    return root?.querySelector('[data-preorder-modal]');
  }

  function openModal(root) {
    const modal = modalFor(root);
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.classList.add('unbegun-preorder-open');
    window.setTimeout(() => modal.querySelector('[data-preorder-confirm]')?.focus(), 20);
  }

  function closeModal(root, { returnFocus = true } = {}) {
    const modal = modalFor(root);
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('unbegun-preorder-open');
    if (returnFocus) formFor(root)?.querySelector('[data-add-button]')?.focus();
  }

  function hasRecentConfirmation(root) {
    return Number(root?.dataset.confirmedUntil || 0) > Date.now();
  }

  function intercept(event, root) {
    if (!isPreorder(root) || hasRecentConfirmation(root)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    openModal(root);
  }

  function confirm(root) {
    closeModal(root, { returnFocus: false });

    root.dataset.confirmedUntil = String(Date.now() + 1500);

    const form = formFor(root);
    if (!form) return;
    update(root);

    const button = form.querySelector('[data-add-button]');

    if (button) {
      button.click();
    } else {
      form.requestSubmit();
    }
  }

  function selectedVariant(root) {
    const form = formFor(root);
    const selector = form?.querySelector('[data-variant-select]');
    const id = selector?.value || form?.querySelector('[name="id"]')?.value;
    return (root._variants || []).find((v) => String(v.id) === String(id));
  }

  function isPreorder(root) {
    const v = selectedVariant(root);
    return Boolean(v && v.inventory_management === 'shopify' &&
      Number(v.inventory_quantity) <= 0 && v.inventory_policy === 'continue');
  }

  function update(root) {
    const active = isPreorder(root);
    root.hidden = !active;
    root.querySelectorAll('[data-preorder-technical-property], [data-preorder-visible-property], [data-preorder-lead-time-property]')
      .forEach((input) => { input.disabled = !active; });
    const delivery = formFor(root)?.querySelector('[data-unbegun-delivery]');
    const stock = delivery?.querySelector('[data-unbegun-stock-message]');
    if (stock) {
      const v = selectedVariant(root);
      stock.hidden = !v || !v.available || active;
    }
    if (!active && !modalFor(root)?.hidden) closeModal(root, { returnFocus: false });
  }

  function init(root) {
    if (root.dataset.preorderReady === 'true') return;
    root.dataset.preorderReady = 'true';

    const form = formFor(root);
    if (!form) return;
    try { root._variants = JSON.parse(root.dataset.variants || '[]'); }
    catch (_) { root._variants = []; }
    const refresh = () => window.requestAnimationFrame(() => update(root));
    form.querySelector('[data-variant-select]')?.addEventListener('change', refresh);
    form.querySelectorAll('select[name^="options["], input[name^="options["]').forEach((el) => el.addEventListener('change', refresh));
    update(root);

    const button = form.querySelector('[data-add-button]');

    button?.addEventListener(
      'click',
      (event) => intercept(event, root),
      true
    );

    form.addEventListener(
      'submit',
      (event) => intercept(event, root),
      true
    );

    root
      .querySelector('[data-preorder-confirm]')
      ?.addEventListener('click', () => confirm(root));

    root
      .querySelectorAll('[data-preorder-cancel]')
      .forEach((element) =>
        element.addEventListener('click', () => closeModal(root))
      );

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeModal(root);
      }
    });
  }

  function boot() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  window.UnbegunPreorder = {
    appendToPayload(payload) {
      return payload;
    }
  };
})();